// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineProjectMonth  {
    _originalTypeClassName = "Loom.BO.TimelineProjectMonth";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineProjectMonth.translate = translateService;
}
this.projectMonth = null;
this.year = null;
this.month = null;
this.TimelineProjectMonthKey = null;
this._key = this.TimelineProjectMonthKey = 0; 
}

static translate: TranslateService;
_key: any;
projectMonth:any;
year:any;
month:any;
private _TimelineProjectMonthKey:any;
get TimelineProjectMonthKey(): any {
    return this._TimelineProjectMonthKey;
  }
set TimelineProjectMonthKey(value: any) {
    this._TimelineProjectMonthKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineProjectMonthKey == null || $this.TimelineProjectMonthKey == 0;
            }


}